import getEnvironment from "../helpers/getEnvironment";
import { getBatteryGradeData } from "../utilities/getBatteryGradeData";
import {
  getBeautyImagesCount,
  getDamageImagesCount,
} from "../utilities/getImagesCount";
import { Image } from "../vehicleDetails/vehicle-details-dto.type";
import { EvBattery } from "../vehicleDetails/vehicle-details.type";

export const formatDate = (isoDateString: string) => {
  if (!isoDateString || isoDateString.length === 0) {
    return "";
  }

  const date = new Date(isoDateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;

  const dd = day < 10 ? `0${day}` : day;
  const mm = month < 10 ? `0${month}` : month;
  const yyyy = date.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};

const pushPageView = ({
  pageVariant,
  userType,
  peep_analyticsid,
  ssoId,
  casId,
  isVendorAdmin,
  vrm,
  saleCode,
  lotNumber,
  saleType,
  location,
  saleStartDate,
  saleEndDate,
  vehicleId,
  hasHpi = false,
  images = [],
  mechanicalReportAnalyticsData = "",
  vehicleType = "",
  evBattery = {} as EvBattery,
  isSalvageVehicle = false,
  vin = "",
}: {
  peep_analyticsid: string;
  ssoId: string;
  casId: string;
  userType: string;
  isVendorAdmin: boolean;
  vin?: string;
  vrm: string;
  saleCode: string;
  lotNumber: string;
  saleType: string;
  location: string;
  saleStartDate: string;
  saleEndDate: string;
  vehicleId: string;
  hasHpi: boolean;
  images: Image[];
  mechanicalReportAnalyticsData: string;
  pageVariant: string;
  vehicleType: string;
  evBattery: EvBattery;
  isSalvageVehicle: boolean;
}) => {
  if (getEnvironment() === "localhost") {
    return;
  }

  let mechanicalReportData = mechanicalReportAnalyticsData.toString();

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    digitalData.push({
      event: { name: "pageview" },
      pageInfo: {
        pageTitle: document.title,
        pagePath: "/lot",
        previousPage: "",
        pageVariant,
      },
      journey: {
        name: "vehicle-details",
      },
      user: {
        userType: userType,
        sfId: "", //once we have integration SF we need to capture ID for easy link up
        aaId: peep_analyticsid, //customerAccountUserID|peep_analyticsID
        ssoId: ssoId, //SSOID|sub
        cas: casId, //sourceaccount_Id
        authenticated: "is-logged-in",
        isVendorAdmin: isVendorAdmin.toString() ?? "false",
      },
      product: {
        vehicle: [
          {
            vin, // not available
            vrm,
            unitPrice: "", // not available
            dealerId: "", // not available
            saleCode,
            lotCode: lotNumber,
            saleCountry: "gb",
            saleType: saleType,
            saleBranch: location,
            saleStartDate: formatDate(saleStartDate),
            saleEndDate: formatDate(saleEndDate),
            vehId: vehicleId,
            hpiSpecFlag: hasHpi ? "hpi-available" : "hpi-is-not-available",
            mechReportCombo: mechanicalReportData,
            vehicleType,
            batteryGrade: getBatteryGradeData(evBattery),
            salvageDeclaration: isSalvageVehicle,
          },
        ],
        image: {
          damageImageFlag:
            getDamageImagesCount(images) > 0
              ? "damage-images-available"
              : "damage-images-not-available",
          totalImagesAvailable: images?.length || 0,
          totalDamageImagesAvailable: getDamageImagesCount(images),
          totalBeautyImagesAvailable: getBeautyImagesCount(images),
        },
      },
    });
    //@ts-ignore
    digitalData.push({ event: { name: "prodview" } });
  }
};

export default pushPageView;
